// extracted by mini-css-extract-plugin
module.exports = {"label":"Text_label__1htmW","value":"Text_value__2RgwA"};